import { Route, Switch } from "react-router-dom";
import {
  PATH_WORK_LOGS_EDIT,
  PATH_WORK_LOGS_PAYEE,
  PATH_WORK_LOGS_PAYEE_TAB_APPROVED,
  PATH_WORK_LOGS_PAYEE_DETAILS,
  PATH_WORK_LOGS_PAYEE_TAB_IN_PROGRESS,
  PATH_WORK_LOGS_PAYEE_TAB_REJECTED,
  PATH_WORK_LOGS_PAYEE_TAB_SUBMITTED,
  PATH_WORK_LOGS_PAYER,
  PATH_WORK_LOGS_PAYER_TAB_APPROVED,
  PATH_WORK_LOGS_PAYER_TAB_DASHBOARD,
  PATH_WORK_LOGS_PAYER_DETAILS,
  PATH_WORK_LOGS_PAYER_TAB_REJECTED,
  PATH_WORK_LOGS_PAYER_TAB_IN_PROGRESS,
  PATH_WORK_LOGS_PAYER_TAB_TO_APPROVE
} from "./paths";
import { RouteEdit } from "./routes/RouteEdit";
import { RoutePayeeLogs } from "./routes/RoutePayeeLogs";
import { RoutePayeeWorkLogDetails } from "./routes/RoutePayeeWorkLogDetails";
import { RoutePayerLogs } from "./routes/RoutePayerLogs";
import { RoutePayerWorkLogDetails } from "./routes/RoutePayerWorkLogDetails";

export const WorkLogs = () => {
  return (
    <Switch>
      <Route path={PATH_WORK_LOGS_EDIT} component={RouteEdit} />

      <Route
        exact
        path={[
          PATH_WORK_LOGS_PAYEE_TAB_IN_PROGRESS,
          PATH_WORK_LOGS_PAYEE_TAB_SUBMITTED,
          PATH_WORK_LOGS_PAYEE_TAB_APPROVED,
          PATH_WORK_LOGS_PAYEE_TAB_REJECTED,
          PATH_WORK_LOGS_PAYEE
        ]}
        component={RoutePayeeLogs}
      />

      <Route
        path={PATH_WORK_LOGS_PAYEE_DETAILS}
        component={RoutePayeeWorkLogDetails}
      />

      <Route
        exact
        path={[
          PATH_WORK_LOGS_PAYER_TAB_DASHBOARD,
          PATH_WORK_LOGS_PAYER_TAB_TO_APPROVE,
          PATH_WORK_LOGS_PAYER_TAB_APPROVED,
          PATH_WORK_LOGS_PAYER_TAB_REJECTED,
          PATH_WORK_LOGS_PAYER_TAB_IN_PROGRESS,
          PATH_WORK_LOGS_PAYER
        ]}
        component={RoutePayerLogs}
      />

      <Route
        path={PATH_WORK_LOGS_PAYER_DETAILS}
        component={RoutePayerWorkLogDetails}
      />
    </Switch>
  );
};
